import React, { useState } from "react";
import PropTypes from "prop-types";

import {
    Box,
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    Typography,
    TextField,
    IconButton,
    InputLabel,
    Tabs,
    Tab,
    Paper,
} from "@material-ui/core";
import AddBoxIcon from "@material-ui/icons/AddBox";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import HelpOutlineRoundedIcon from "@material-ui/icons/HelpOutlineRounded";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import clientConfig from "../../../config/client";
import {
    rateChangeOperations,
    STATE_DATE_FORMAT,
    MAX_LINES_FOR_DATE,
    editRateByRuleFormType,
    MATERIAL_UI_PROPS,
    SHOW_DATE_FORMAT,
    VALUE_TYPES,
} from "../../../lib/data";
import {
    createAccObjFromStr,
    formatAccType,
    strFromAccTarget,
} from "../../../lib/helperFuncs.jsx";
import {
    editButtonTheme as back,
    toggleButtonTheme as submit,
} from "../../../config/theme";
import ControlButtons from "../../ControlButtons/ControlButtons.jsx";

const locale = clientConfig.locale;
const MIN_DAYS_GAP_AMNT = 1;
const MAX_DAYS_BETWEEN_START_AND_END_DATES = 365;
const MAX_RULES_AMNT = 6;
const NOT_ALLOWED_SYMBOLS_REGEX = /[+,-]/g;
const MAX_CHARS_IN_ROOM_NAME = 30;
const BASE_LINE_ID = "base_line_id";

const DIALOG_LABELS = {
    dialogTitle: {
        type: {
            assign: {
                label: { ru: "Присвоение стоимости", en: "Assign price" },
            },
            calculate: {
                label: {
                    ru: "Изменение стоимости по параметрам",
                    en: "Room rate change by rules",
                },
            },
            calculate_multiple: {
                label: {
                    ru: "Расчет стоимости дополнительных категорий",
                    en: "Calculate additional room categories",
                },
            },
        },
    },
    currentRoomType: {
        label: { ru: "Базовый тип комнаты", en: "Base room type" },
        helperText: {
            ru: "Тип комнаты используемы как базовый (совпадает с выбранным в сетке)",
            en: "Room type used as base (same as selected in grid)",
        },
        defaultName: { ru: "Нет данных", en: "No data" },
    },
    tabsTypes: {
        assign: { label: { ru: "Присвоение", en: "Assign" } },
        calculate: { label: { ru: "Расчет", en: "Calculate" } },
        calculate_multiple: {
            label: { ru: "Расчет нескольких", en: "Calculate multiple" },
        },
    },
    datePickers: {
        intervalErrMsg: {
            maxErr: {
                ru: "Дата не может быть позднее максимальной",
                en: "Date should not be after maximal date",
            },
            minErr: {
                ru: "Дата не может быть ранее минимальной",
                en: "Date should not be before minimal date",
            },
        },

        date_start: {
            type: "date_start",
            label: { ru: "Дата начала", en: "Date start" },
            invalidMsg: {
                ru: "Некорректная форма даты начала",
                en: "Invalid form start date format",
            },
        },
        date_end: {
            type: "date_end",
            label: { ru: "Дата окончания", en: "Date end" },
            invalidMsg: {
                ru: "Некорректная форма даты окончания",
                en: "Invalid form end date format",
            },
        },
    },
    baseData: {
        label: { ru: "Исходные тип размещения", en: "Base accomodation type" },
        description: {
            adults: { ru: "Взрослых", en: "Adults" },
            children: { ru: "Детей", en: "Children" },
            babies: { ru: "Младенцев", en: "Babbies" },
        },
        helperText: {
            ru: "Тип размещения, данные которого будут использованы для последующей генерации стоимости проживания",
            en: "Type, which data will be used for further creating of selected accomodation type price",
        },
    },
    dataLine: {
        accOpts: { label: { ru: "Тип размещения", en: "Accomodation type" } },
        operationOpts: { label: { ru: "Операция", en: "Operation" } },
        valueType: { label: { ru: "Тип значения", en: "Value type" } },
        valueInput: { label: { ru: "Значение", en: "Value" } },
    },
    addDataLine: {
        label: { ru: "Добавить новое правило", en: "Add new rule line" },
    },
    deleteDataLine: { label: { ru: "Удалить правило", en: "Remove rule" } },
    addRoomType: {
        label: { ru: "Добавить категорию номера", en: "Add room type" },
    },
    deleteRoomType: {
        label: { ru: "Удалить категорию номера", en: "Remove room category" },
    },
    addDateInterval: {
        label: { ru: "Добавить интервал", en: "Add interval" },
    },
    deleteDateInterval: {
        label: { ru: "Удалить интервал", en: "Remove interval" },
    },
    actionsBtnLabels: {
        save: { label: { ru: "Сохранить", en: "Save" } },
        cancel: { label: { ru: "Отмена", en: "Cancel" } },
    },
    textFieldHelperText: { ru: "Ошибка в поле ввода", en: "Input field error" },
    additionalRoomTypes: { label: { ru: "Тип комнаты", en: "Room type" } },
};
const dateFieldStyle = {
    marginTop: 0,
    width: "11.5rem",
};

const RoomRateEditByRule = (props) => {
    const [roomTypeVariant, setRoomTypeVariant] = useState("none");
    const [placeTypePrice, setPlaceTypePrice] = useState("basePrice");
    const [notRend, setNotRend] = useState(false);
    const buttons = [
        {
            type: back,
            icon: <CancelIcon />,
            caption: DIALOG_LABELS.actionsBtnLabels.cancel.label[locale],
            action: () => props.setIsOpenRulesModule(false),
        },
        {
            type: submit,
            icon: <SaveIcon />,
            caption: DIALOG_LABELS.actionsBtnLabels.save.label[locale],
            action: () => {
                props.startCalculationWithRules(
                    props.rulesForChange,
                    props.editFormType,
                    roomTypeVariant,
                    placeTypePrice,
                );
                props.setIsOpenRulesModule(false);
            },
        },
    ];

    const formTypesArr = Object.keys(editRateByRuleFormType);

    const changeFormHandler = (_, newFormTypeIdx) => {
        const newFormType = formTypesArr[newFormTypeIdx];

        if (newFormType === props.editFormType) return;

        props.setEditFormType(newFormType);
    };

    const changeDateHandler = (dateValue, dateType, idx) => {
        const updatedRulesToChange = { ...props.rulesForChange };
        const newDateStr = dateValue.format(STATE_DATE_FORMAT);

        updatedRulesToChange.date_array[idx][dateType] = newDateStr;
        const changeddDate = moment(newDateStr, STATE_DATE_FORMAT);
        const toChangeDate =
            dateType === DIALOG_LABELS.datePickers.date_start.type
                ? moment(
                      updatedRulesToChange.date_array[idx].date_end,
                      STATE_DATE_FORMAT,
                  )
                : moment(
                      updatedRulesToChange.date_array[idx].date_start,
                      STATE_DATE_FORMAT,
                  );

        if (dateType === DIALOG_LABELS.datePickers.date_start.type) {
            if (
                toChangeDate.isBefore(changeddDate) ||
                changeddDate.isSame(toChangeDate)
            ) {
                const newEndDateStr = changeddDate.format(STATE_DATE_FORMAT);

                updatedRulesToChange.date_array[idx].date_end = newEndDateStr;
            }
        } else if (dateType === DIALOG_LABELS.datePickers.date_end.type) {
            if (
                toChangeDate.isAfter(changeddDate) ||
                changeddDate.isSame(toChangeDate)
            ) {
                const newStartDateStr = changeddDate.format(STATE_DATE_FORMAT);

                updatedRulesToChange.date_array[idx].date_start =
                    newStartDateStr;
            }
        }

        props.setRulesForChange(updatedRulesToChange);
    };

    const addLine = (lineName) => {
        let maxLines = MAX_RULES_AMNT;
        let valForNewLine = [];

        switch (lineName) {
            case "data":
                maxLines = props.accomodTypes.length;
                valForNewLine = [...props.accomodTypes];
                break;
            case "date_array":
                maxLines = MAX_LINES_FOR_DATE;
                valForNewLine = [...props.rulesForChange[lineName]];
                break;
            case "additional_room_types":
                maxLines = props.roomTypes.length - 1;
                valForNewLine = [...props.roomTypes];
                break;
        }

        if (props.rulesForChange[lineName].length < maxLines) {
            const updatedLines = [...props.rulesForChange[lineName]];
            const copyLastLine = { ...updatedLines[updatedLines.length - 1] };

            const newLine = createNextLine(
                copyLastLine,
                lineName,
                valForNewLine,
            );

            updatedLines.push(newLine);

            return props.setRulesForChange((prevRules) => ({
                ...prevRules,
                [lineName]: updatedLines,
            }));
        }
    };

    const removeLine = (idx, lineName) => {
        if (props.rulesForChange[lineName].length > 1) {
            const updatedLines = [...props.rulesForChange[lineName]];

            updatedLines.splice(idx, 1);

            return props.setRulesForChange((prevRules) => ({
                ...prevRules,
                [lineName]: updatedLines,
            }));
        }
    };

    const changeRuleLine = (
        event,
        lineIdx,
        fieldName,
        lineTypeName,
        itemsForSelection,
    ) => {
        const updatedData = [...props.rulesForChange[lineTypeName]];
        const updatedLine = { ...updatedData[lineIdx] };
        let newValue;
        let auxValue;

        switch (fieldName) {
            case "target":
                newValue = createAccObjFromStr(
                    itemsForSelection[event.target.value],
                );
                updatedLine[fieldName] = newValue;
                break;
            case "value":
                auxValue = event.target.value
                    .trim()
                    .replace(NOT_ALLOWED_SYMBOLS_REGEX, "");
                newValue = auxValue;
                updatedLine[fieldName] = newValue;
                if (
                    (!newValue || newValue === "0") &&
                    updatedLine.operation === rateChangeOperations.divide.value
                ) {
                    updatedLine.operation = rateChangeOperations.add.value;
                }
                break;
            case "value_type":
                newValue = event.target.value;
                updatedLine[fieldName] = newValue;
                if (
                    updatedLine.operation ===
                        rateChangeOperations.multiply.value ||
                    updatedLine.operation === rateChangeOperations.divide.value
                ) {
                    updatedLine.operation = rateChangeOperations.add.value;
                }
                break;
            default:
                newValue = event.target.value;
                updatedLine[fieldName] = newValue;
                break;
        }

        updatedData[lineIdx] = updatedLine;

        return props.setRulesForChange((prevRules) => ({
            ...prevRules,
            [lineTypeName]: updatedData,
        }));
    };

    const { roomTypeName, fullRoomTypeName } = getRoomTypeName(
        props.rulesForChange.room_type_id,
        props.roomTypes,
    );

    const createRoomTypeLine = (roomTypes, rules) => {
        if (rules && rules.length > 0) {
            const labelLine = DIALOG_LABELS.additionalRoomTypes.label[locale];
            return rules.map((rule, ruleIdx) => {
                const idStr = `add_room_type ${rule.room_type_id} ${ruleIdx}`;
                const selectedRoomTypeZero = {};
                selectedRoomTypeZero.name = "Выберите тип номера";
                const selectedRoomType =
                    roomTypes.find((item) => item.id === rule.room_type_id) ??
                    selectedRoomTypeZero;

                return (
                    <Box
                        key={idStr}
                        mb={3}
                        display={"flex"}
                        alignItems={"center"}
                        className="forAllState"
                    >
                        <Box>
                            <Box mb={2}>
                                <FormControl
                                    variant={
                                        MATERIAL_UI_PROPS.varinats.outlined
                                    }
                                    size={MATERIAL_UI_PROPS.sizes.small}
                                    id={idStr}
                                    style={{ width: "26.8rem" }}
                                >
                                    <InputLabel id={idStr}>
                                        {labelLine}
                                    </InputLabel>
                                    <Select
                                        title={selectedRoomType.name}
                                        labelId={idStr}
                                        id={idStr}
                                        label={labelLine}
                                        value={rule.room_type_id}
                                        onChange={(e) =>
                                            changeRuleLine(
                                                e,
                                                ruleIdx,
                                                "room_type_id",
                                                "additional_room_types",
                                                roomTypes.map(
                                                    (roomType) => roomType.id,
                                                ),
                                            )
                                        }
                                    >
                                        {roomTypes.map((roomType, rtIdx) => (
                                            <MenuItem
                                                key={`roomTypeOpt ${rtIdx}`}
                                                value={roomType.id}
                                            >
                                                {roomType.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>

                            {!notRend && (
                                <Box
                                    className="forAllExceptState"
                                    display={"flex"}
                                >
                                    <Box mr={2}>
                                        {createOperationSelectItem(
                                            rule.operation,
                                            rateChangeOperations,
                                            changeRuleLine,
                                            ruleIdx,
                                            "operation",
                                            rule.value,
                                            "additional_room_types",
                                            rule.value_type,
                                        )}
                                    </Box>
                                    <Box mr={".9rem"}>
                                        {createValueTypeSelection(
                                            rule.value_type,
                                            changeRuleLine,
                                            ruleIdx,
                                            "value_type",
                                            "additional_room_types",
                                        )}
                                    </Box>
                                    {createTextField(
                                        rule.value,
                                        changeRuleLine,
                                        ruleIdx,
                                        "value",
                                        props.editFormType,
                                        "additional_room_types",
                                    )}
                                </Box>
                            )}
                        </Box>
                        <Box>
                            {createIconBtns(
                                ruleIdx,
                                "addRoomType",
                                "deleteRoomType",
                                addLine,
                                removeLine,
                                rules.length,
                                "additional_room_types",
                            )}
                        </Box>
                    </Box>
                );
            });
        }
    };

    const createRulesLines = (data) => {
        if (data && data.length > 0) {
            const dataElsToShow = data.map((line, lineIdx) => (
                <Box key={lineIdx} display="flex" alignItems="top" mb="1.2rem">
                    <Box mr=".9rem">
                        {createSelectItem(
                            getAccomodTypeIdx(line.target, props.accomodTypes),
                            props.accomodTypes,
                            changeRuleLine,
                            `accomod_type_id:${lineIdx}`,
                            lineIdx,
                            "target",
                        )}
                    </Box>
                    {props.editFormType.includes(
                        editRateByRuleFormType.calculate,
                    ) && (
                        <Box mr=".9rem">
                            {createOperationSelectItem(
                                line.operation,
                                rateChangeOperations,
                                changeRuleLine,
                                lineIdx,
                                "operation",
                                line.value,
                                "data",
                                line.value_type,
                            )}
                        </Box>
                    )}
                    {props.editFormType.includes(
                        editRateByRuleFormType.calculate,
                    ) && (
                        <Box mr={".9rem"}>
                            {createValueTypeSelection(
                                line.value_type,
                                changeRuleLine,
                                lineIdx,
                                "value_type",
                                "data",
                            )}
                        </Box>
                    )}
                    {createTextField(
                        line.value,
                        changeRuleLine,
                        lineIdx,
                        "value",
                        props.editFormType,
                        "data",
                    )}
                    {createIconBtns(
                        lineIdx,
                        "addDataLine",
                        "deleteDataLine",
                        addLine,
                        removeLine,
                        data.length,
                        "data",
                    )}
                </Box>
            ));

            return dataElsToShow;
        }
    };

    const createDatesLines = (dates) => {
        if (dates && dates.length > 0) {
            const datesElsToShow = dates.map((date, lineIdx) => (
                <Box key={lineIdx} display="flex" mb={"1rem"}>
                    <Box mr={"2rem"}>
                        {createDateField(
                            DIALOG_LABELS.datePickers.date_start.type,
                            date.date_start,
                            changeDateHandler,
                            moment(props.rateEnd, STATE_DATE_FORMAT),
                            lineIdx,
                        )}
                    </Box>
                    <Box>
                        {createDateField(
                            DIALOG_LABELS.datePickers.date_end.type,
                            date.date_end,
                            changeDateHandler,
                            moment(props.rateEnd, STATE_DATE_FORMAT),
                            lineIdx,
                            props.rulesForChange.date_start,
                        )}
                    </Box>
                    {createIconBtns(
                        lineIdx,
                        "addDateInterval",
                        "deleteDateInterval",
                        addLine,
                        removeLine,
                        dates.length,
                        "date_array",
                    )}
                </Box>

                // <Box key={lineIdx} display="flex" alignItems="top" mb="1.2rem">
                //     <Box mr=".9rem">
                //         {createSelectItem(
                //             getAccomodTypeIdx(line.target, props.accomodTypes),
                //             props.accomodTypes,
                //             changeRuleLine,
                //             `accomod_type_id:${lineIdx}`,
                //             lineIdx,
                //             "target"
                //         )}
                //     </Box>
                //     {props.editFormType.includes(
                //         editRateByRuleFormType.calculate
                //     ) && (
                //         <Box mr=".9rem">
                //             {createOperationSelectItem(
                //                 line.operation,
                //                 rateChangeOperations,
                //                 changeRuleLine,
                //                 lineIdx,
                //                 "operation",
                //                 line.value,
                //                 "data",
                //                 line.value_type
                //             )}
                //         </Box>
                //     )}
                //     {props.editFormType.includes(
                //         editRateByRuleFormType.calculate
                //     ) && (
                //         <Box mr={".9rem"}>
                //             {createValueTypeSelection(
                //                 line.value_type,
                //                 changeRuleLine,
                //                 lineIdx,
                //                 "value_type",
                //                 "data"
                //             )}
                //         </Box>
                //     )}
                //     {createTextField(
                //         line.value,
                //         changeRuleLine,
                //         lineIdx,
                //         "value",
                //         props.editFormType,
                //         "data"
                //     )}
                // </Box>
            ));

            return datesElsToShow;
        }
    };

    return (
        <Dialog
            open={true}
            onClose={() => props.setIsOpenRulesModule(false)}
            maxWidth={"lg"}
            aria-labelledby="edit_by_rule_title"
        >
            <DialogTitle id="edit_by_rule_title">
                <Box mb={".8rem"} width={"fit-content"}>
                    <Paper elevation={3}>
                        <Tabs
                            value={formTypesArr.indexOf(props.editFormType)}
                            onChange={changeFormHandler}
                            textColor={MATERIAL_UI_PROPS.colors.secondary}
                        >
                            {Object.keys(DIALOG_LABELS.tabsTypes).map(
                                (itemKey) => (
                                    <Tab
                                        key={itemKey}
                                        label={
                                            DIALOG_LABELS.tabsTypes[itemKey]
                                                .label[locale]
                                        }
                                    />
                                ),
                            )}
                        </Tabs>
                    </Paper>
                </Box>
                <Box mb={1}>
                    {
                        DIALOG_LABELS.dialogTitle.type[props.editFormType]
                            .label[locale]
                    }
                </Box>
                <Box>
                    <Typography>
                        {`${DIALOG_LABELS.currentRoomType.label[locale]}: ${roomTypeName}`}
                        {fullRoomTypeName && (
                            <Box component="span" title={fullRoomTypeName}>
                                ...
                            </Box>
                        )}
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent>
                <Box display={"flex"} justifyContent={"space-between"}>
                    <Box mr={2}>
                        {createDatesLines(props.rulesForChange.date_array)}
                        {props.editFormType.includes(
                            editRateByRuleFormType.calculate,
                        ) && createLabel(setPlaceTypePrice)}
                        {props.editFormType.includes(
                            editRateByRuleFormType.calculate,
                        ) &&
                            createDescData(
                                getAccomodTypeIdx(
                                    props.rulesForChange.base,
                                    props.accomodTypes,
                                ),
                                props.accomodTypes,
                            )}
                        <Box
                            pt="1.2rem"
                            style={{ borderTop: "1px solid #808080" }}
                        >
                            {createRulesLines(props.rulesForChange.data)}
                        </Box>
                    </Box>
                    {props.editFormType ===
                        editRateByRuleFormType.calculate_multiple && (
                        <Box>
                            <Box
                                id="roomTypesHand"
                                style={{
                                    marginBottom: "10px",
                                    borderRadius: "5px",
                                    position: "absolute",
                                    top: "50px",
                                }}
                            >
                                <div>
                                    <input
                                        onChange={(ev) =>
                                            roomTypeHandler(
                                                ev,
                                                props.roomTypes,
                                                setRoomTypeVariant,
                                                setNotRend,
                                            )
                                        }
                                        type="checkbox"
                                        id="currentImplementation"
                                        defaultChecked={true}
                                        name="current"
                                    />
                                    <label
                                        style={{ marginLeft: "5px" }}
                                        htmlFor="currentImplementation"
                                    >
                                        Для выбранных с индивидуальными
                                        значениями
                                    </label>
                                </div>
                                <div>
                                    <input
                                        onChange={(ev) =>
                                            roomTypeHandler(
                                                ev,
                                                props.roomTypes,
                                                setRoomTypeVariant,
                                                setNotRend,
                                            )
                                        }
                                        type="checkbox"
                                        id="forAllExcept"
                                        name="AllExcept"
                                    />
                                    <label
                                        style={{ marginLeft: "5px" }}
                                        htmlFor="forAllExcept"
                                    >
                                        Для всех, кроме выбранных
                                    </label>
                                </div>
                                <div>
                                    <input
                                        onChange={(ev) =>
                                            roomTypeHandler(
                                                ev,
                                                props.roomTypes,
                                                setRoomTypeVariant,
                                                setNotRend,
                                            )
                                        }
                                        type="checkbox"
                                        id="forAll"
                                        name="All"
                                    />
                                    <label
                                        style={{ marginLeft: "5px" }}
                                        htmlFor="forAll"
                                    >
                                        Для всех категорий
                                    </label>
                                </div>
                            </Box>

                            <Box pl={2}>
                                {createRoomTypeLine(
                                    props.roomTypes,
                                    props.rulesForChange.additional_room_types,
                                )}
                            </Box>
                        </Box>
                    )}
                </Box>
            </DialogContent>
            <DialogActions>
                <Box
                    display="flex"
                    alignItems="end"
                    justifyContent="flex-start"
                >
                    <Box
                        display="flex"
                        alignItems="flex-start"
                        flexDirection="column"
                        margin="0 270px 15px 15px"
                    >
                        <p>Итерации по вариантам размещения:</p>
                        <Box>
                            <input
                                onChange={(e) =>
                                    iterationsHandler(
                                        "allAcc",
                                        e,
                                        props.baseAccomodTypes,
                                        props.setAccomodTypes,
                                    )
                                }
                                type="checkbox"
                                id="allAcc"
                                defaultChecked="true"
                            />
                            <label
                                style={{ margin: "0 15px 0 2px" }}
                                htmlFor="allAcc"
                            >
                                Все варианты размещения
                            </label>

                            <input
                                onChange={(e) =>
                                    iterationsHandler(
                                        "withExtra",
                                        e,
                                        props.baseAccomodTypes,
                                        props.setAccomodTypes,
                                    )
                                }
                                type="checkbox"
                                id="withExtra"
                            />
                            <label
                                style={{ margin: "0 15px 0 2px" }}
                                htmlFor="withExtra"
                            >
                                С доп местом
                            </label>

                            <input
                                onChange={(e) =>
                                    iterationsHandler(
                                        "withoutChild",
                                        e,
                                        props.baseAccomodTypes,
                                        props.setAccomodTypes,
                                    )
                                }
                                type="checkbox"
                                id="withoutChild"
                            />
                            <label
                                style={{ margin: "0 15px 0 2px" }}
                                htmlFor="withoutChild"
                            >
                                Без детей
                            </label>

                            <input
                                onChange={(e) =>
                                    iterationsHandler(
                                        "withChild",
                                        e,
                                        props.baseAccomodTypes,
                                        props.setAccomodTypes,
                                    )
                                }
                                type="checkbox"
                                id="withChild"
                            />
                            <label
                                style={{ margin: "0 15px 0 2px" }}
                                htmlFor="withChild"
                            >
                                С детьми
                            </label>
                        </Box>
                    </Box>
                    {buttons && <ControlButtons items={buttons} />}
                </Box>
            </DialogActions>
        </Dialog>
    );
};

const getAccomodTypeIdx = (baseAcommodType, accTypesArr) => {
    let strForArr = `${baseAcommodType.adults}.${baseAcommodType.children}.${baseAcommodType.babies}.${baseAcommodType.extra_bed}.${baseAcommodType.craddle}`;

    if (accTypesArr.includes(strForArr)) {
        return accTypesArr.findIndex((accStr) => strForArr === accStr);
    }

    return 0;
};

const recreationRadio = (type, checked, ids, setNotRend = null) => {
    const els = [];
    ids.forEach((i) => els.push(document.getElementById(i)));

    if (!checked) {
        type = ids[0];
        els[0].checked = true;
    }

    els.forEach((el) => {
        if (el.id === type) return;
        el.checked = false;
    });

    switch (type) {
        case "forAll":
            document.getElementById("roomTypesHand").style.position =
                "relative";
            hideClassHandler("forAllState", "none");
            hideClassHandler("forAllExceptState", "flex");
            break;
        case "forAllExcept":
            setNotRend(true);
            document.getElementById("roomTypesHand").style.position =
                "absolute";
            hideClassHandler("forAllState", "flex");
            hideClassHandler("forAllExceptState", "none");
            break;
        case "currentImplementation":
            setNotRend(false);
            document.getElementById("roomTypesHand").style.position =
                "absolute";
            hideClassHandler("forAllState", "flex");
            hideClassHandler("forAllExceptState", "flex");
            break;
    }
};

const hideClassHandler = (className, state) => {
    const classes = document.getElementsByClassName(className);
    for (let i = 0; i < classes.length; i++) {
        classes[i].style.display = state;
    }
};

const roomTypeHandler = (e, all, setVariant, setNotRend) => {
    let type = e.target.id;
    recreationRadio(
        type,
        e.target.checked,
        ["currentImplementation", "forAll", "forAllExcept"],
        setNotRend,
    );

    const element = {};
    element.variant = type;

    if (type !== "currentImplementation") {
        const allIds = all.map((i) => {
            return i.id;
        });
        element.allId = allIds;
    }

    setVariant(element);
};

const iterationsHandler = (type, e, values, newSet, baseAcc) => {
    recreationRadio(type, e.target.checked, [
        "allAcc",
        "withExtra",
        "withoutChild",
        "withChild",
    ]);

    let newAcc = [];
    if (type === "withExtra") {
        values.forEach((a) => {
            const accArr = a.split(".");
            if (accArr[3] == 1) newAcc.push(a);
        });
    }

    if (type === "withoutChild") {
        values.forEach((a) => {
            const accArr = a.split(".");
            if (accArr[1] == 0) newAcc.push(a);
        });
    }

    if (type === "withChild") {
        values.forEach((a) => {
            const accArr = a.split(".");
            if (accArr[1] == 1) newAcc.push(a);
        });
    }

    if (type === "allAcc") {
        newAcc = values;
    }

    newSet(newAcc);
};

const priceHandler = (e, setPlaceTypePrice) => {
    let type = e.target.id;
    recreationRadio(type, e.target.checked, ["basePrice", "specPrice"]);

    if (e.target.checked && type === "specPrice")
        setPlaceTypePrice("specPrice");
    else setPlaceTypePrice("basePrice");
};

const createDateField = (
    dateType,
    dateValue,
    changeDateFunc,
    rateEndMoment,
    idx,
    curDateStart,
) => {
    let maxSelectableDate = rateEndMoment;
    let minSelectableDate = moment();

    if (dateType === "date_start") {
        maxSelectableDate = maxSelectableDate;
    } else if (dateType === "date_end" && curDateStart) {
        const dateStartMoment = moment(curDateStart, STATE_DATE_FORMAT);
        const restrictedMaxDate = dateStartMoment.add(
            MAX_DAYS_BETWEEN_START_AND_END_DATES,
            "d",
        );
        if (maxSelectableDate.isAfter(restrictedMaxDate)) {
            maxSelectableDate = restrictedMaxDate;
        }
        minSelectableDate = minSelectableDate;
    }

    return (
        <MuiPickersUtilsProvider
            libInstance={moment}
            utils={MomentUtils}
            locale={locale}
        >
            <DatePicker
                label={DIALOG_LABELS.datePickers[dateType].label[locale]}
                style={dateFieldStyle}
                maxDate={maxSelectableDate}
                maxDateMessage={
                    DIALOG_LABELS.datePickers.intervalErrMsg.maxErr[locale]
                }
                minDate={minSelectableDate}
                minDateMessage={
                    DIALOG_LABELS.datePickers.intervalErrMsg.minErr[locale]
                }
                size={MATERIAL_UI_PROPS.sizes.small}
                variant={MATERIAL_UI_PROPS.varinats.inline}
                format={SHOW_DATE_FORMAT}
                invalidDateMessage={
                    DIALOG_LABELS.datePickers[dateType].invalidMsg[locale]
                }
                value={dateValue}
                inputVariant={MATERIAL_UI_PROPS.varinats.outlined}
                onChange={(dateMoment) =>
                    changeDateFunc(dateMoment, dateType, idx)
                }
            />
        </MuiPickersUtilsProvider>
    );
};

const createTextField = (
    value,
    valueChangeFn,
    lineIdx,
    lineField,
    formType,
    lineType,
) => (
    <TextField
        error={!value}
        helperText={!value && DIALOG_LABELS.textFieldHelperText[locale]}
        style={{
            ...(formType.includes(editRateByRuleFormType.calculate) && {
                maxWidth: "9rem",
            }),
        }}
        label={DIALOG_LABELS.dataLine.valueInput.label[locale]}
        value={value}
        variant={MATERIAL_UI_PROPS.varinats.outlined}
        size={MATERIAL_UI_PROPS.sizes.small}
        inputProps={{ type: "number" }}
        onChange={(e) => valueChangeFn(e, lineIdx, lineField, lineType)}
    />
);

const createValueTypeSelection = (
    value,
    changeFn,
    lineIdx,
    fieldType,
    lineName,
) => {
    const labelLine = DIALOG_LABELS.dataLine.valueType.label[locale];
    const labelId = `dataline_${lineIdx}valueType`;

    return (
        <FormControl
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            size={MATERIAL_UI_PROPS.sizes.small}
            style={{ minWidth: "7rem" }}
        >
            <InputLabel id={labelId}>{labelLine}</InputLabel>
            <Select
                title={labelLine}
                labelId={labelId}
                id={labelId}
                label={labelLine}
                value={VALUE_TYPES[value].value}
                onChange={(e) => changeFn(e, lineIdx, fieldType, lineName)}
            >
                {Object.keys(VALUE_TYPES).map((type, idx) => (
                    <MenuItem
                        key={`accomodOpt/${idx}`}
                        value={VALUE_TYPES[type].value}
                    >
                        {VALUE_TYPES[type].label[locale]}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

const createOperationSelectItem = (
    value,
    availableValuesObj,
    changeFn,
    lineIdx,
    fieldType,
    enteredValue,
    lineName,
    valueType,
) => {
    const updatedAvailValsObj = { ...availableValuesObj };
    const availableValuesArr = [];
    const labelId = `dataline_${lineIdx}operationOpts_label`;
    const labelLine = DIALOG_LABELS.dataLine.operationOpts.label[locale];

    if (valueType === "percent") {
        Reflect.deleteProperty(updatedAvailValsObj, "multiply");
        Reflect.deleteProperty(updatedAvailValsObj, "divide");
        Reflect.deleteProperty(updatedAvailValsObj, "equally");
    }

    Object.keys(updatedAvailValsObj).forEach(
        (key) =>
            !(enteredValue == 0 && key === "divide") &&
            availableValuesArr.push(updatedAvailValsObj[key]),
    );

    return (
        <FormControl
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            size={MATERIAL_UI_PROPS.sizes.small}
            style={{ minWidth: "9rem" }}
        >
            <InputLabel id={labelId}>{labelLine}</InputLabel>
            <Select
                labelId={labelId}
                id={labelId}
                label={labelLine}
                value={updatedAvailValsObj[value]?.value}
                onChange={(e) => changeFn(e, lineIdx, fieldType, lineName)}
            >
                {availableValuesArr.map((option, idx) => (
                    <MenuItem key={`accomodOpt/${idx}`} value={option.value}>
                        {option.label[locale]}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

const createSelectItem = (val, valsArr, changeFn, elId, lineIdx, fieldType) => {
    const labelId = `dataline_${lineIdx}accOpt_label`;
    const labelLine = DIALOG_LABELS.dataLine.accOpts.label[locale];

    return (
        <FormControl
            variant={MATERIAL_UI_PROPS.varinats.outlined}
            size={MATERIAL_UI_PROPS.sizes.small}
            id={elId}
            style={{ minWidth: "9rem" }}
        >
            <InputLabel id={labelId}>{labelLine}</InputLabel>
            <Select
                labelId={labelId}
                id={labelId}
                label={labelLine}
                value={val}
                onChange={(e) =>
                    changeFn(e, lineIdx, fieldType, "data", valsArr)
                }
            >
                {valsArr.map((option, idx) => (
                    <MenuItem key={`accomodOpt/${idx}`} value={idx}>
                        {formatAccType(option)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

const createDescData = (curVal, options) => {
    const [adults, children, babies] = options[curVal].split(".");

    return (
        <Box display="flex" alignItems="center" pb={".5rem"}>
            {createElWithData(adults, "adults")}
            {createElWithData(children, "children")}
            {createElWithData(babies, "babies")}
        </Box>
    );
};

const createLabel = (setPlaceTypePrice) => (
    <Box style={{ display: "flex" }}>
        <label htmlFor={BASE_LINE_ID}>
            <Box display={"flex"} alignItems={"center"} pb={".5rem"}>
                <Box mr={".5rem"}>
                    <Typography>
                        {DIALOG_LABELS.baseData.label[locale]}
                    </Typography>
                </Box>
                <Box
                    display={"flex"}
                    alignItems={"center"}
                    title={DIALOG_LABELS.baseData.helperText[locale]}
                >
                    <HelpOutlineRoundedIcon
                        fontSize={MATERIAL_UI_PROPS.sizes.small}
                    />
                </Box>
            </Box>
        </label>
        <Box style={{ marginLeft: "30px" }}>
            <div>
                <input
                    onChange={(event) => priceHandler(event, setPlaceTypePrice)}
                    type="checkbox"
                    id="basePrice"
                    defaultChecked={true}
                    name="basePrice"
                />
                <label style={{ marginLeft: "5px" }} htmlFor="basePrice">
                    Рассчитывать от цены исходного типа размещения
                </label>
            </div>
            <div>
                <input
                    onChange={(event) => priceHandler(event, setPlaceTypePrice)}
                    type="checkbox"
                    id="specPrice"
                    name="specPrice"
                />
                <label style={{ marginLeft: "5px" }} htmlFor="specPrice">
                    Рассчитывать от цены текущего типа размещения
                </label>
            </div>
        </Box>
    </Box>
);

const createElWithData = (data, dataType) => {
    return (
        <Box component="span" mr={".5rem"}>
            <Typography>
                {DIALOG_LABELS.baseData.description[dataType][locale]} : {data}
            </Typography>
        </Box>
    );
};

const createIconBtns = (
    idx,
    addLabel,
    deleteLabel,
    addFn,
    delFn,
    totalAmnt,
    linesTypeName,
) => (
    <Box padding=".2rem" ml=".4rem" mt=".095rem">
        {idx === totalAmnt - 1 ? (
            <IconButton
                size={MATERIAL_UI_PROPS.sizes.small}
                onClick={() => addFn(linesTypeName)}
                title={DIALOG_LABELS[addLabel].label[locale]}
            >
                <AddBoxIcon color={MATERIAL_UI_PROPS.colors.primary} />
            </IconButton>
        ) : (
            <IconButton
                size={MATERIAL_UI_PROPS.sizes.small}
                onClick={() => delFn(idx, linesTypeName)}
                title={DIALOG_LABELS[deleteLabel].label[locale]}
            >
                <CancelIcon color={MATERIAL_UI_PROPS.colors.secondary} />
            </IconButton>
        )}
    </Box>
);

const getRoomTypeName = (roomId, roomValues) => {
    const roomTypeToShowName = {
        roomTypeName: DIALOG_LABELS.currentRoomType.defaultName[locale],
    };

    if (roomValues && roomValues.length > 0) {
        const selectedRoomType = roomValues.find((item) => item.id === roomId);
        roomTypeToShowName.roomTypeName = selectedRoomType.name;

        if (roomTypeToShowName.roomTypeName.length > MAX_CHARS_IN_ROOM_NAME) {
            roomTypeToShowName.fullRoomTypeName =
                roomTypeToShowName.roomTypeName;
            roomTypeToShowName.roomTypeName =
                roomTypeToShowName.roomTypeName.substring(
                    0,
                    MAX_CHARS_IN_ROOM_NAME,
                );
        }
    }

    return roomTypeToShowName;
};

const createNextLine = (prevLine, lineType, valuesArr) => {
    const lineToReturn = { ...prevLine };

    if (lineType === "data") {
        const idxSelected = valuesArr.findIndex(
            (item) => item === strFromAccTarget(prevLine.target),
        );
        if (idxSelected === valuesArr.length - 1) return lineToReturn;

        lineToReturn.target = createAccObjFromStr(valuesArr[idxSelected + 1]);
    } else if (lineType === "additional_room_types") {
        const idxSelected = valuesArr.findIndex(
            (item) => item.id === prevLine.room_type_id,
        );
        if (idxSelected === valuesArr.length - 1) return lineToReturn;

        lineToReturn.room_type_id = valuesArr[idxSelected + 1].id;
    }

    return lineToReturn;
};

RoomRateEditByRule.propTypes = {
    setIsOpenRulesModule: PropTypes.func.isRequired,
    rateEnd: PropTypes.string.isRequired,
    accomodTypes: PropTypes.array,
    rulesForChange: PropTypes.object,
    setRulesForChange: PropTypes.func,
    startCalculationWithRules: PropTypes.func,
    editFormType: PropTypes.string.isRequired,
    setEditFormType: PropTypes.func.isRequired,
    roomTypes: PropTypes.array.isRequired,
};

export default RoomRateEditByRule;
